import clsx from "clsx";

import styles from "./ProductSelection.module.scss";
import Selectable, { SelectableType } from "../support/Selectable";
import BodyText from "../support/BodyText";

type ProductSelectionProps = {
  label: string;
  onChange: (checked: boolean) => void;
  selected: boolean;
  selectionType?: SelectableType;
  priceLabel?: string;
  disabled?: boolean;
};

export default function ProductSelection({
  label,
  selected,
  onChange,
  priceLabel,
  selectionType = SelectableType.CheckBox,
  disabled = false,
}: ProductSelectionProps) {
  return (
    <div
      className={clsx(styles.container, {
        [styles.disabled]: disabled,
      })}
      onClick={disabled ? undefined : () => onChange(!selected)}
      role="presentation"
    >
      <Selectable
        type={selectionType}
        checked={selected}
        disabled={disabled}
        onClick={() => onChange(!selected)}
      />
      <div className={styles.contentContainer}>
        <BodyText>{label}</BodyText>
        {/* TODO: Replace with SpotlightText */}
        {priceLabel && <BodyText>{priceLabel}</BodyText>}
      </div>
    </div>
  );
}
